module.exports = __webpack_public_path__ + "resources/img/img_magic_line_m.a189f15e1f4bbd81ad5bb182871f0b98.png";